import CheckboxGroup from "../../applicationUi/components/intake/CheckboxGroup";
import TextAreaField from "../../applicationUi/components/intake/TextAreaField";
import InputField from "../../applicationUi/components/intake/InputField";
import RadioGroup from "../../applicationUi/components/intake/RadioGroup";
const AcademicImpactSection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-8">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">G - Academic/Social Impact</h2>
      <p className="text-sm text-muted-foreground">
        How communication affects academic and social situations.
      </p>
    </div>

    {/* How does speech and language difficulty impact day-to-day life? */}
    <h3 className="font-semibold mb-2">
      How does the speech and language difficulty impact your child on a
      day-to-day basis?
    </h3>

    {/* Multiple checkbox options for day-to-day impact */}
    <div className="space-y-4">
      <label className="text-sm font-medium text-foreground block">Day-to-day Impact</label>
      <div className="space-y-3">
        {[
          { name: "shy", label: "Shy" },
          { name: "actingOut", label: "Acting Out" },
          { name: "teased", label: "Teased" },
          { name: "avoidsTalking", label: "Avoids Talking" },
          { name: "avoidsEyeContact", label: "Avoids Eye Contact" },
        ].map((option) => (
          <div
            key={option.name}
            className={`flex items-start space-x-3 p-3 rounded-sm border transition-colors ${
              isReadOnly
                ? "border-gray-200 bg-gray-50"
                : formData.academicSocialImpact.impactOnDayToDay?.[option.name]
                ? "border-primary bg-primary/5"
                : "border-gray-200 bg-background hover:border-gray-300 hover:bg-accent/30"
            }`}
          >
            <input
              type="checkbox"
              id={`impactOnDayToDay-${option.name}`}
              name={`academicSocialImpact.impactOnDayToDay.${option.name}`}
              checked={formData.academicSocialImpact.impactOnDayToDay?.[option.name] || false}
              onChange={handleChange}
              disabled={isReadOnly}
              className={`h-4 w-4 rounded-sm border transition-colors focus:ring-1 focus:ring-ring focus:ring-offset-0 ${
                isReadOnly
                  ? "border-gray-200 bg-gray-50 cursor-not-allowed"
                  : "border-gray-200 text-primary hover:border-gray-300 focus:border-primary"
              }`}
            />
            <label
              htmlFor={`impactOnDayToDay-${option.name}`}
              className={`text-sm leading-relaxed ${
                isReadOnly ? "text-muted-foreground cursor-not-allowed" : "text-foreground cursor-pointer"
              }`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>

    <TextAreaField
      label="Other (please specify)"
      name="academicSocialImpact.impactOnDayToDay.other"
      value={formData.academicSocialImpact.impactOnDayToDay.other}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Academic Performance */}
    <InputField
      label="Academic Performance"
      name="academicSocialImpact.academicPerformance"
      value={formData.academicSocialImpact.academicPerformance}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Playmates */}
    <RadioGroup
      label="Does your child have playmates?"
      name="academicSocialImpact.hasPlaymates"
      options={[
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ]}
      selectedValue={formData.academicSocialImpact.hasPlaymates}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Conditional fields for playmates */}
    {formData.academicSocialImpact.hasPlaymates === "yes" && (
      <>
        <InputField
          label="How old are they?"
          name="academicSocialImpact.playmatesAge"
          value={formData.academicSocialImpact.playmatesAge}
          onChange={handleChange}
          readOnly={isReadOnly}
        />
        <TextAreaField
          label="How do they interact together?"
          name="academicSocialImpact.interactionWithPlaymates"
          value={formData.academicSocialImpact.interactionWithPlaymates}
          onChange={handleChange}
          readOnly={isReadOnly}
        />
      </>
    )}

    {/* Interaction with siblings */}
    <TextAreaField
      label="How does your child get along with their siblings?"
      name="academicSocialImpact.siblingsInteraction"
      value={formData.academicSocialImpact.siblingsInteraction}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Favorite activities at home */}
    <TextAreaField
      label="Favourite activities at home?"
      name="academicSocialImpact.favoriteActivitiesAtHome"
      value={formData.academicSocialImpact.favoriteActivitiesAtHome}
      onChange={handleChange}
          readOnly={isReadOnly}
    />
  </section>
);

export default AcademicImpactSection;
